<main role="main" >
    <section>
        <article>
            <app-tandarts-header></app-tandarts-header>
            <app-tandarts-content></app-tandarts-content>
        </article>
    </section>
</main>